'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _ = require('..');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _RealtorPublishContactCompany = require('./RealtorPublishContactCompany.scss');var _RealtorPublishContactCompany2 = _interopRequireDefault(_RealtorPublishContactCompany);
var _helpers = require('../CompanyInPropertiesList/helpers');var _helpers2 = _interopRequireDefault(_helpers);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

RealtorPublishContactCompany = function (_Component) {_inherits(RealtorPublishContactCompany, _Component);function RealtorPublishContactCompany() {var _temp, _this, _ret;_classCallCheck(this, RealtorPublishContactCompany);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      showText: false }, _this.


    fetchReCaptchaToken = function (token) {
      _this.setState({ captcha: token });
    }, _this.

    handleClose = function () {
      _this.props.hideMessageModal();
      _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/manage_properties'));
    }, _this.

    sendConsultation = function () {var _this$props =



















      _this.props,locale = _this$props.locale,_this$props$sharingPr = _this$props.sharingPropertyData,sharingUrl = _this$props$sharingPr.sharingUrl,propertyId = _this$props$sharingPr.propertyId,accessToken = _this$props.userAuthentication.accessToken,id = _this$props.companyData.id,neighborhood = _this$props.propertyData.address.en.neighborhood;

      _this.props.contactAgencyOnPropertyCreation({
        access_token: accessToken,
        data: {
          agency_id: id,
          neighborhood: neighborhood,
          property_id: propertyId,
          property_link: sharingUrl,
          locale: locale } });


      _this.handleClose();
    }, _temp), _possibleConstructorReturn(_this, _ret);}RealtorPublishContactCompany.prototype.

  render = function render() {var _props =









    this.props,translate = _props.translate,companyData = _props.companyData,locale = _props.locale,sharingPropertyData = _props.sharingPropertyData,handleShareClick = _props.handleShareClick,address = _props.propertyData.address;

    var neighborhoodAgent = (0, _helpers2.default)(
    (companyData || {}).assigned_neighborhoods,
    address.en.city_name,
    address.en.neighborhood) ||
    {};

    return (
      _react2.default.createElement('div', { className: _RealtorPublishContactCompany2.default.wrapper },
        _react2.default.createElement('div', { className: _RealtorPublishContactCompany2.default.iconWrapper },
          _react2.default.createElement('span', { className: 'icon icon-house-simple' },
            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' }),
            _react2.default.createElement('span', { className: 'path3' }))),


        _react2.default.createElement('p', { className: _RealtorPublishContactCompany2.default.title },
          translate('title')),

        !!companyData &&
        _react2.default.createElement('p', { className: _RealtorPublishContactCompany2.default.subTitle },
          translate('subTitle')),


        _react2.default.createElement('p', { className: _RealtorPublishContactCompany2.default.text },
          !companyData ?
          translate('noCompanyInfoText') :
          translate('infoText')),


        !!companyData && _react2.default.createElement('div', { className: _RealtorPublishContactCompany2.default.companyWrapper },
          _react2.default.createElement('div', { className: _RealtorPublishContactCompany2.default.company },
            _react2.default.createElement('img', {
              src: neighborhoodAgent.image || companyData.image,
              alt: '' }),

            _react2.default.createElement('div', { className: _RealtorPublishContactCompany2.default.infoCompanyWrapper },
              _react2.default.createElement('p', { className: _RealtorPublishContactCompany2.default.nameCompany },
                neighborhoodAgent.name || companyData.name[locale] || companyData.name.he),

              _react2.default.createElement('div', { className: _RealtorPublishContactCompany2.default.propertiesCompany },
                _react2.default.createElement('i', { className: 'icon icon-home' }), ' ', companyData.properties_count, ' ', translate('properties'))))),




        _react2.default.createElement('div', { className: _RealtorPublishContactCompany2.default.buttonWrapper },
          !!companyData ?
          _react2.default.createElement('button', { className: _RealtorPublishContactCompany2.default.yes, onClick: this.sendConsultation }, translate('buttonYes')) :
          _react2.default.createElement(_.ShareFacebookButton, {
            sharingData: sharingPropertyData,
            title: translate('share').toString(),
            handleClick: handleShareClick,
            className: _RealtorPublishContactCompany2.default.yes }),


          _react2.default.createElement('button', { className: _RealtorPublishContactCompany2.default.no, onClick: this.handleClose },
            !!companyData ?
            translate('buttonNo') :
            translate('okay')))));





  };return RealtorPublishContactCompany;}(_react.Component);exports.default = RealtorPublishContactCompany;


RealtorPublishContactCompany.propTypes = {
  translate: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  withPayments: _propTypes2.default.bool,
  companyData: _propTypes2.default.object,
  propertyData: _propTypes2.default.object,
  userAuthentication: _propTypes2.default.object,
  handleShareClick: _propTypes2.default.func,
  contactAgencyOnPropertyCreation: _propTypes2.default.func,
  sharingPropertyData: _propTypes2.default.object };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorPublishContactCompany/RealtorPublishContactCompany.js
// module id = 2878
// module chunks = 0